import { AutoFactory, DynamicApplicationGMIFormLink, HMDAGMIApi } from '@sageworks/jpi';

export const formIsComplete = async (gmiFormLink: DynamicApplicationGMIFormLink): Promise<boolean> => {
	if (gmiFormLink.id == null) return false;

	const gmiService = AutoFactory.get(HMDAGMIApi);
	let isComplete = await gmiService.formIsComplete(gmiFormLink.id);
	return isComplete;
};
